var _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g5, _g6, _g7, _g8, _g9, _g0, _rect, _path10, _rect2, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphoneFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 737,
    viewBox: "0 0 367 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99957 156.385C1.99957 155.769 2.49679 155.269 3.11041 155.269H5.89422L5.89422 208.437H3.11041C2.49691 208.437 1.99957 207.936 1.99957 207.32L1.99957 156.385Z",
    fill: "#E1E1E1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99957 156.385C1.99957 155.769 2.49679 155.269 3.11041 155.269H5.89422L5.89422 208.437H3.11041C2.49691 208.437 1.99957 207.936 1.99957 207.32L1.99957 156.385Z",
    stroke: "#D2D2D2",
    strokeWidth: 2.29167
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99957 222.985C1.99957 222.369 2.49679 221.869 3.11041 221.869L5.89422 221.869L5.89422 275.037H3.11041C2.49691 275.037 1.99957 274.536 1.99957 273.92L1.99957 222.985Z",
    fill: "#E1E1E1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99957 222.985C1.99957 222.369 2.49679 221.869 3.11041 221.869L5.89422 221.869L5.89422 275.037H3.11041C2.49691 275.037 1.99957 274.536 1.99957 273.92L1.99957 222.985Z",
    stroke: "#D2D2D2",
    strokeWidth: 2.29167
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00043 104.339C2.00043 103.721 2.49764 103.22 3.11127 103.22H5.89508L5.89508 132.323H3.11127C2.49777 132.323 2.00043 131.824 2.00043 131.204L2.00043 104.339Z",
    fill: "#E1E1E1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00043 104.339C2.00043 103.721 2.49764 103.22 3.11127 103.22H5.89508L5.89508 132.323H3.11127C2.49777 132.323 2.00043 131.824 2.00043 131.204L2.00043 104.339Z",
    stroke: "#D2D2D2",
    strokeWidth: 2.29167
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.105 172.059H363.611C364.378 172.059 365 172.683 365 173.456V257.408C365 258.18 364.379 258.806 363.611 258.806H361.105V172.059Z",
    fill: "#E1E1E1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.105 172.059H363.611C364.378 172.059 365 172.683 365 173.456V257.408C365 258.18 364.379 258.806 363.611 258.806H361.105V172.059Z",
    stroke: "#D2D2D2",
    strokeWidth: 2.29167
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 56.2386C8.00005 27.9402 30.7934 4.99982 58.9095 4.99982L308.091 4.99982C336.207 4.99982 359 27.9392 359 56.2386L359 680.761C359 709.059 336.207 732 308.091 732H58.9095C30.793 732 8.00005 709.06 8.00005 680.761L8.00005 56.2386Z",
    stroke: "#D1D1D1",
    strokeWidth: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63.4271C18 38.2017 38.118 17.9998 62.6331 17.9998L304.367 17.9998C328.881 17.9998 349 38.2026 349 63.4271L349 672.573C349 697.798 328.882 718 304.367 718H62.6331C38.1186 718 18 697.797 18 672.573L18 63.4271Z",
    stroke: "#FAFAFA",
    strokeWidth: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.098 74.9573H362.218V80.5539H356.098V74.9573Z",
    fill: "#D6D6D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7813 74.9573H10.9015V80.5539H4.7813V74.9573Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.098 657.005H362.218V662.602H356.098V657.005Z",
    fill: "#D6D6D6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7813 657.005H10.9015V662.602H4.7813V657.005Z",
    fill: "#D6D6D6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0001 15.9998H276V34.4998C276 44.7171 267.717 52.9998 257.5 52.9998H111.5C101.283 52.9998 93.0001 44.7171 93.0001 34.4998V15.9998Z",
    fill: "#F9F9F9"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.644 38.5796C148.487 38.5796 149.982 37.0761 149.982 35.2216C149.982 33.367 148.487 31.8636 146.644 31.8636C144.8 31.8636 143.305 33.367 143.305 35.2216C143.305 37.0761 144.8 38.5796 146.644 38.5796Z",
    fill: "#F0F0F0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.643 37.46C147.872 37.46 148.869 36.4577 148.869 35.2213C148.869 33.985 147.872 32.9827 146.643 32.9827C145.414 32.9827 144.418 33.985 144.418 35.2213C144.418 36.4577 145.414 37.46 146.643 37.46Z",
    fill: "#D7D7D7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.973 40.818C227.045 40.818 229.536 38.3123 229.536 35.2214C229.536 32.1305 227.045 29.6248 223.973 29.6248C220.9 29.6248 218.409 32.1305 218.409 35.2214C218.409 38.3123 220.9 40.818 223.973 40.818Z",
    fill: "#F0F0F0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.972 39.6988C226.43 39.6988 228.423 37.6942 228.423 35.2215C228.423 32.7488 226.43 30.7442 223.972 30.7442C221.514 30.7442 219.521 32.7488 219.521 35.2215C219.521 37.6942 221.514 39.6988 223.972 39.6988Z",
    fill: "#D7D7D7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.002 32.9827H202.276C203.505 32.9827 204.501 33.9851 204.501 35.2213C204.501 36.4576 203.505 37.46 202.276 37.46H165.002C163.773 37.46 162.777 36.4576 162.777 35.2213C162.777 33.9851 163.773 32.9827 165.002 32.9827",
    fill: "#F0F0F0"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.003 34.1021H202.276C202.891 34.1021 203.389 34.6033 203.389 35.2215C203.389 35.8397 202.891 36.3408 202.276 36.3408H165.003C164.388 36.3408 163.89 35.8397 163.89 35.2215C163.89 34.6033 164.388 34.1021 165.003 34.1021Z",
    fill: "#D7D7D7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 309.577,
    y: 41.5024,
    width: 16.1893,
    height: 8.01515,
    rx: 2.16667,
    stroke: "#DCDCDC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M327.047 43.9191V47.1009C327.676 46.8315 328.085 46.2046 328.085 45.51C328.085 44.8155 327.676 44.1886 327.047 43.9191",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 310.639,
    y: 42.5934,
    width: 14.0641,
    height: 5.83333,
    rx: 1.33333,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.18 42.8172C300.918 42.8173 302.59 43.4967 303.85 44.715C303.945 44.8091 304.096 44.8079 304.19 44.7123L305.097 43.7814C305.144 43.7329 305.17 43.6673 305.17 43.599C305.169 43.5307 305.142 43.4654 305.095 43.4175C301.788 40.1942 296.572 40.1942 293.265 43.4175C293.217 43.4654 293.19 43.5307 293.189 43.599C293.189 43.6672 293.215 43.7329 293.263 43.7814L294.17 44.7123C294.263 44.808 294.415 44.8092 294.51 44.715C295.77 43.4966 297.442 42.8172 299.18 42.8172ZM299.18 45.846C300.135 45.8459 301.056 46.207 301.764 46.8591C301.86 46.9516 302.011 46.9496 302.104 46.8546L303.01 45.9236C303.057 45.8748 303.084 45.8086 303.083 45.7397C303.082 45.6709 303.055 45.6052 303.006 45.5574C300.85 43.5175 297.512 43.5175 295.356 45.5574C295.307 45.6052 295.279 45.6709 295.279 45.7398C295.278 45.8086 295.305 45.8749 295.352 45.9236L296.258 46.8546C296.351 46.9496 296.502 46.9516 296.598 46.8591C297.305 46.2074 298.226 45.8464 299.18 45.846ZM300.994 47.8838C300.996 47.9528 300.969 48.0194 300.921 48.0677L299.354 49.6761C299.308 49.7234 299.245 49.75 299.18 49.75C299.115 49.75 299.052 49.7234 299.006 49.6761L297.439 48.0677C297.391 48.0193 297.364 47.9528 297.365 47.8837C297.367 47.8147 297.396 47.7493 297.447 47.7031C298.447 46.8422 299.913 46.8422 300.913 47.7031C300.964 47.7494 300.993 47.8148 300.994 47.8838Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.501 41.2676H287.72C287.288 41.2676 286.939 41.6237 286.939 42.063V48.957C286.939 49.3963 287.288 49.7524 287.72 49.7524H288.501C288.933 49.7524 289.283 49.3963 289.283 48.957V42.063C289.283 41.6237 288.933 41.2676 288.501 41.2676ZM284.074 43.1236H284.855C285.287 43.1236 285.636 43.4798 285.636 43.9191V48.957C285.636 49.3963 285.287 49.7524 284.855 49.7524H284.074C283.642 49.7524 283.292 49.3963 283.292 48.957V43.9191C283.292 43.4798 283.642 43.1236 284.074 43.1236ZM281.209 44.9797H280.428C279.996 44.9797 279.646 45.3358 279.646 45.7752V48.957C279.646 49.3963 279.996 49.7524 280.428 49.7524H281.209C281.64 49.7524 281.99 49.3963 281.99 48.957V45.7752C281.99 45.3358 281.64 44.9797 281.209 44.9797ZM277.563 46.5706H276.781C276.35 46.5706 276 46.9268 276 47.3661V48.957C276 49.3963 276.35 49.7524 276.781 49.7524H277.563C277.994 49.7524 278.344 49.3963 278.344 48.957V47.3661C278.344 46.9268 277.994 46.5706 277.563 46.5706Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7343 45.464V45.492C61.7063 47.256 61.3003 48.88 59.5503 48.88C58.5283 48.88 58.0243 48.292 57.9263 47.55H56.3023C56.4983 49.006 57.7163 50.21 59.5363 50.21C61.9723 50.21 63.3583 48.432 63.3583 45.128C63.3583 42.23 62.3643 40.116 59.5363 40.116C57.3663 40.116 56.0363 41.6 56.0363 43.504C56.0363 45.408 57.3383 46.724 59.2423 46.724C60.3623 46.724 61.2583 46.248 61.7343 45.464ZM59.5923 41.446C60.8803 41.446 61.6503 42.244 61.6503 43.392C61.6503 44.582 60.7963 45.394 59.5083 45.394C58.4023 45.394 57.6183 44.652 57.6183 43.42C57.6183 42.244 58.3463 41.446 59.5923 41.446ZM65.0638 45.814C65.5678 45.814 65.9598 45.464 65.9598 44.904C65.9598 44.358 65.5678 43.994 65.0638 43.994C64.5458 43.994 64.1538 44.358 64.1538 44.904C64.1538 45.464 64.5458 45.814 65.0638 45.814ZM65.0638 50.112C65.5678 50.112 65.9598 49.762 65.9598 49.202C65.9598 48.656 65.5678 48.292 65.0638 48.292C64.5458 48.292 64.1538 48.656 64.1538 49.202C64.1538 49.762 64.5458 50.112 65.0638 50.112ZM72.8723 50V47.802H74.2303V46.43H72.8723V40.326H71.2483L66.6703 46.29V47.802H71.2483V50H72.8723ZM71.2483 42.342V46.43H68.1123L71.2483 42.342ZM76.6196 40.326C76.5216 41.516 76.0176 42.384 74.2676 42.384V43.546C75.0796 43.546 75.7236 43.546 76.2976 42.986V50H77.9216V40.326H76.6196Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii",
    x: 0.853737,
    y: 154.123,
    width: 6.18632,
    height: 57.7512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.9167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4583
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii",
    x: 0.853737,
    y: 220.723,
    width: 6.18632,
    height: 57.7511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.9167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4583
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii",
    x: 0.854591,
    y: 102.075,
    width: 6.18632,
    height: 33.6857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.9167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4583
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii",
    x: 359.96,
    y: 170.913,
    width: 6.18629,
    height: 91.3307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.9167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4583
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i",
    x: 143.305,
    y: 31.8636,
    width: 6.67653,
    height: 9.0076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i",
    x: 144.418,
    y: 32.9827,
    width: 4.45099,
    height: 6.76897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.363734 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i",
    x: 218.409,
    y: 29.6248,
    width: 11.1276,
    height: 13.4849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i",
    x: 219.521,
    y: 30.7442,
    width: 8.90198,
    height: 11.2463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.363734 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i",
    x: 162.777,
    y: 32.9827,
    width: 41.7241,
    height: 6.76897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i",
    x: 163.89,
    y: 34.1021,
    width: 39.4989,
    height: 4.53032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.363734 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneFrame);
export default __webpack_public_path__ + "static/media/iphone-frame.f1ae2f5cb751c1a85b847ab16b27a42a.svg";
export { ForwardRef as ReactComponent };